import React, { useState, lazy, Suspense } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Table } from "reactstrap";
import {
  addContactAction,
  deleteContactAction
} from "../../redux/actions/contacts.actions";
import BasicSearchRow from "../BasicSearchRow";
import PropTypes from "prop-types";
import "./styles.scss";
import { Translate } from "react-localize-redux";
// import ProfileCardModal from "../modals/ProfileCardModal";
const ProfileCardModal = lazy(() => import("../modals/ProfileCardModal"));

const ContactsTable = ({
 addContactAction,
 contacts,
 deleteContactAction,
 loggedIn,
 history,
 showContactAction,
 loggedInUser
}) => {
  const [modalOpen, setModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
  console.log("User" + loggedInUser)
  console.log(loggedInUser)
  console.warn("help")
  return (
    <React.Fragment>
      {contacts && !!contacts.length && (
        <div>
        <Table borderless className="contacts-layout" size="sm">
          <thead id="table-headings">
          <tr>
            <th>
              <strong>
                <Translate id="nameText"/>
              </strong>
            </th>
            <th>
              <strong>
                <Translate id="cityText"/>
              </strong>
            </th>
            <th>
              <strong>
                <Translate id="numberText"/>
              </strong>
            </th>
            <th/>
          </tr>
          </thead>
          <tbody>
          {contacts.map((contact, index) => (
            <BasicSearchRow
              rowItem={contact}
              key={contact.id}
              contacts={contact.contacts}
              onAdd={addContactAction}
              onRemove={deleteContactAction}
              isUserLoggedIn={loggedIn}
              showContactAction={showContactAction}
              onRowClick={() => {
                setSelectedRow(index);
                setModalOpen(true);
              }}
            />
          ))}
          </tbody>
        </Table>
        <Suspense fallback={<div>Loading...</div>}>
          <ProfileCardModal
          onToggle={() => {
            setModalOpen(!modalOpen);
          }}
          isOpen={modalOpen}
          profile={contacts[selectedRow]}
          loggedInUser={loggedInUser}
          isUserLoggedIn={loggedIn}
          onAdd={addContactAction}
          onRemove={deleteContactAction}
          // contacts={contacts}
        />
      </Suspense>
        </div>
      )}
    </React.Fragment>
  );
};

ContactsTable.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.object)
};

const mapStateToProps = state => ({
  // contacts: state.profile.profile.contacts,
  loggedInUser: state.profile.profile,
  loggedIn: state.auth.loggedIn
});

export default withRouter(connect(
  mapStateToProps,
  {
    addContactAction,
    deleteContactAction
  }
)(ContactsTable));



// WEBPACK FOOTER //
// ./src/components/ContactsTable/ContactsTable.jsx